//Functions
import { formatTelephoneForFront } from "@/support/functions/telephone.functions";
import { formatDate } from "@/support/functions/date.functions";

export default class profileModel {
    birthday
    email
    facebookConnected
    genderId
    image
    name
    telephone
    cpf
    cidade
    city

    constructor( object ) {
        this.image = (object && object.image )? object.image : null;
        this.birthday = (object && object.birthday )? formatDate(object.birthday) : null;
        this.email = (object && object.email )? object.email : null;
        this.cidade = (object && object.cidade )? object.cidade : null;
        this.city = (object && object.city )? object.city : null;
        this.genderId = (object && object.genderId )? object.genderId : null;
        this.name = (object && object.name )? object.name : null;
        this.telephone = (object && object.telephone )? formatTelephoneForFront(object.telephone) : null;
        this.facebookConnected = (object && object.facebookConnected )? object.facebookConnected : null;
        this.cpf = ( object && object.cpf ) ? object.cpf : null;
    }

}